import {HotspotDotLinkRaw} from "./HotspotDotLinkRaw";

export class HotspotDotLink implements HotspotDotLinkRaw{

  constructor(
    public id: string,
    public baseId: string,
    public title: string,
    public link: string,
    public file: string,
    public hasImage?: boolean,
    public hasLink?: boolean,
    public children?: HotspotDotLink[]) {
  }
}
